import { OccupationEntity } from '../entities/occupation-entity';

export default class State {
  loaded = false;

  items: Array<OccupationEntity> = [];
}
